import { withStylePrefix } from '../../common/withStylePrefix';
import { NavigationDrawerSectionComponent, navigationDrawerSectionTemplate } from './NavigationDrawerSection';
import styles from './NavigationDrawerSection.styles.scss';
export const navigationDrawerSectionDefinition = {
    baseName: 'navigation-drawer-section',
    template: navigationDrawerSectionTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonNavigationDrawerSection = NavigationDrawerSectionComponent.compose(navigationDrawerSectionDefinition);
